import ToolBase from '../basic';
import DEFINE from '../define';
import { fabric } from 'fabric';
import EventBus from '../../event_bus';
import GraphicBoardProxy from '../graphic_board_proxy';
export default class GraphicBoard extends ToolBase {
    boardImage = "./image/paint_board/paint_board.svg";
    boardTitle = "";
    name = DEFINE.TOOLS.GRAPHIC_BOARD;

    currentBoard = null;
    moving = false;
    constructor(parent) {
        super(parent);
        GraphicBoardProxy.Instance.pageCanvas = this.canvas;
    }
    recover(o) {
        this.registerEvent(o);
        o.set({
            hasBorders: false,
            hasControls: false,
            subTargetCheck: true
        });
        GraphicBoardProxy.Instance.recoverGraphicBoardPainter(o.tag);
        console.log("recover graphic board::", o);
    }
    mouseUp(o) {
        let pointer = this.canvas.getPointer(o.e);
        this.parent.proxy.changeTool(null);
        this.point = {
            x: pointer.x,
            y: pointer.y
        }
        this.createBoard(this.point.x, this.point.y);
    }
    createBoard(x, y) {
        const txt = new fabric.Text(this.boardTitle, {
            fontSize: 20
        });

        fabric.Image.fromURL(this.boardImage, (image) => {
            const icon = image;
            icon.scaleToWidth(50, true);
            icon.setCoords();

            const group = new fabric.Group([icon, txt], {
                tag: DEFINE.TAG.GRAPHIC_BOARD + new Date().getTime(),
                toolType: this.name,
                title: this.boardTitle,
                left: x,
                top: y,
                width: 100,
                height: 73.6,
                hasBorders: false,
                hasControls: false,
                subTargetCheck: true
            });

            txt.set({
                left: -txt.getScaledWidth() * 0.5,
                top: txt.getScaledHeight() * 0.5
            });
            console.log("txt:", txt.getScaledHeight() + icon.getScaledHeight());

            icon.set({
                left: 0,
                top: -group.getScaledHeight() * 0.5,
                originX: "center"
            });
            this.currentBoard = group;
            this.registerEvent(group);

            this.openAndSetBoard(group.title, group.tag, group);

            this.canvas.add(group);
            console.log("create canvas::", this.canvas);
            this.canvas.renderAll();
        });
    }
    /**
     * 註冊事件
     * @param {fabric.Group} group 
     */
    registerEvent(group) {
        const self = this;
        group.on("mousedown", (e) => {
            self.currentBoard = group;
            self.moving = false;
        });
        group.on("moving", (e) => {
            self.moving = true;
            self.currentBoard = null;
            self.canvas.renderAll();
        });
        group.on("mouseup", (e) => {
            if (e.target == self.currentBoard && self.moving == false) {
                self.openAndSetBoard(group.title, group.tag, group);
            }
        });
    }
    openAndSetBoard(title, id, group) {
        const data = {
            title: title,
            id: id,
            board: group
        };
        EventBus.getInstance().emit("openGraphicBoard", data);
        GraphicBoardProxy.Instance.currentBoard = group;
    }
    setTitle(title) {
        this.currentBoard.title = title;
        console.log("text:", this.currentBoard.getObjects("Text"));
    }
}